
import { prototype } from 'module';
<template>
  <div>
    <div class='clpp-api-name clpp-api-title' :class="{'clpp-api-deprecated': isDeprecated}">
      <span>
        {{signatureWithParams}}
        <badge :label="b" v-for="b in badges" :key='b'/>
      </span>
    </div>

    <div class='clpp-api-level'>

      <div class='v-space' v-if='isDeprecated'>
        <h4>Deprecated</h4>
        <div class='clpp-api-level'>
          <div v-html="deprecatedMessage">{{deprecatedMessage}}</div>
        </div>
      </div>

      <div class='clpp-api-description v-space' v-html="description" v-if='description'>{{description}}</div>

      <div class='v-space' v-if='parameters.length'>
        <h4>Parameters</h4>
        <div class='clpp-api-level clpp-api-prop-table'>
          <table>
            <thead>
              <tr>
                <th class="name-header-column">Name</th>
                <th class="type-header-column">Type</th>
                <th class="description-header-column" width="100%">Description</th>
              </tr>
            </thead>
            <tbody>
              <DocsDetailParameter v-for='p in parameters' :key='p.___id' :entry='p'/>
            </tbody>
          </table>
        </div>
      </div>

      <div class='v-space' v-if='exceptions.length'>
        <h4 >Throws</h4>
        <div class='clpp-api-level'>
          <DocsDetailThrows v-for='p in exceptions' :key='p.___id' :entry='p'/>
        </div>
      </div>

      <div class='v-space' v-if='returns.length'>
        <h4>Returns</h4>
        <div class='clpp-api-level'>
          <DocsDetailReturns v-for='p in returns' :key='p.___id' :entry='p'/>
        </div>
      </div>

      <div class='v-space' v-if='examples.length'>
        <h4>Examples</h4>
        <div class='clpp-api-level'>
          <DocsDetailExample v-for='p in examples' :key='p.___id' :entry='entry' :example='p'/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DocsDetailParameter from './DocsDetailParameter.vue';
import DocsDetailThrows from './DocsDetailThrows.vue';
import DocsDetailReturns from './DocsDetailReturns.vue';
import DocsDetailExample from './DocsDetailExample.vue';
import { DocsComponentMixin } from '../../utils/docs';
import Badge from '../Badge';

export default {
  mixins: [DocsComponentMixin],

  name: 'DocsDetailFunction',
  components: {
    Badge,
    DocsDetailParameter,
    DocsDetailThrows,
    DocsDetailReturns,
    DocsDetailExample
  }
};
</script>
